// Shared helpers for audit / inspection reports.
// Ported from the RN previous-inspection screen so the web audit renders the
// same labels, odometer unit, and 12-hour time format.

export const HOURS_VEHICLE_TYPES = new Set([1, 2, 3, 4, 11, 13])

export const US_JURISDICTIONS = new Set([
    'AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN',
    'IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH',
    'NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT',
    'VT','VA','WA','WV','WI','WY','PR','GU','VI','AS','MP',
])

// Web `vehicleData.type` is a 3-char code ("001".."013"); RN uses the 1-based
// index. Map the code to the same index space so HOURS_VEHICLE_TYPES applies.
function typeCodeToIndex(vType) {
    if (vType == null) return NaN
    if (typeof vType === 'number') return vType
    const s = String(vType).trim()
    const asInt = parseInt(s, 10)
    return Number.isFinite(asInt) ? asInt : NaN
}

export function resolveOdometerUnit(vehicleData = {}, vType) {
    const override = (vehicleData.odometerUnit ?? '').toString().trim().toLowerCase()
    if (override === 'km' || override === 'mi' || override === 'hrs') return override
    const idx = typeCodeToIndex(vType ?? vehicleData.type)
    if (HOURS_VEHICLE_TYPES.has(idx)) return 'hrs'
    const jur = (vehicleData.jurisdiction ?? '').toString().trim().toUpperCase()
    if (US_JURISDICTIONS.has(jur)) return 'mi'
    return 'km'
}

// Strip a trailing unit suffix the web pipeline pre-formats onto odometer.
export function stripOdometerSuffix(raw) {
    if (raw == null) return ''
    const s = String(raw).trim()
    const m = s.match(/^(-?\d+(?:\.\d+)?)/)
    return m ? m[1] : s
}

export function formatDate12h(input) {
    const date = input instanceof Date ? input : new Date(input)
    if (Number.isNaN(date.getTime())) {
        return { formattedDate: '', time: '' }
    }
    const month = date.getMonth() + 1
    const day = date.getDate()
    const formattedDate = `${date.getFullYear()}/${month}/${day}`

    const h24 = date.getHours()
    const ampm = h24 >= 12 ? 'PM' : 'AM'
    const h12 = h24 % 12 === 0 ? 12 : h24 % 12
    const m = date.getMinutes()
    const mm = m < 10 ? `0${m}` : `${m}`
    return { formattedDate, time: `${h12}:${mm} ${ampm}` }
}

export function getStatusLabel(condition) {
    const n = typeof condition === 'number' ? condition : parseInt(String(condition ?? ''), 10)
    if (n === 0) return 'Good'
    if (n === 1) return 'Monitor'
    if (n === 2) return 'Action Required'
    return 'Good'
}

function nonEmptyOr(value, fallback) {
    const s = (value ?? '').toString().trim()
    return s.length > 0 ? s : fallback
}

export function getOperatorName(metadata = {}) {
    return nonEmptyOr(metadata.operatorName, 'Not Available')
}

export function getInspectorName(metadata = {}) {
    return nonEmptyOr(metadata.name, 'Not Available')
}
